/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { ValidationStatus } from '@gh/builder-shared-data';
import { UserContext } from '@gh/common-shared';
import { Enum } from '@gh/core-data';

import { createMessageBasketFromResponse } from '@gh/core-messages';
import { DialogService, NotificationRef, NotificationService } from '@gh/core-ui';
import { throwError$ } from '@gh/rx';
import { catchError$ } from '@gh/rx/operators';

import { Observable } from 'rxjs';
import { userProfileValidationDialogRoute } from '../components';

@Injectable()
export class LogoutHttpErrorInterceptor implements HttpInterceptor {
  private mapboxNotificationShown = false;
  private mapboxNotificationRef: NotificationRef | null = null;

  constructor(private injector: Injector) {

  }

  get dialogService(): DialogService {
    // we take DialogService from injector directly to avoid circular dependencies
    return this.injector.get(DialogService);
  }

  get userContext(): UserContext {
    // we take DialogService from injector directly to avoid circular dependencies
    return this.injector.get(UserContext);
  }

  get notificationService(): NotificationService {
    return this.injector.get(NotificationService);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(catchError$((response: HttpErrorResponse) => {
      const isMapboxApiRequest = req.url && req.url.includes('api.mapbox.com');
      if (isMapboxApiRequest && response.status >= 400 && !this.mapboxNotificationShown) {
        this.mapboxNotificationShown = true;
        this.mapboxNotificationRef = this.notificationService.warning('The autofill address functionality is currently unavailable. Kindly enter the address manually.');
        setTimeout(() => {
          if (this.mapboxNotificationRef) {
            this.mapboxNotificationRef.close();
            this.mapboxNotificationRef = null;
          }
          this.mapboxNotificationShown = false;
        }, 20000);
      }
      if (this.userContext.isInitialized() && response.status === 401 && !response.headers.has('X-No-Auth-Refresh') && !isMapboxApiRequest) {
        // return this.translationLoader.load()
        const basket = response.error ? createMessageBasketFromResponse(response) : void 0;
        const message = basket ? Enum.byValue(ValidationStatus, basket.at(0).key) || ValidationStatus.LoginDenied
          : ValidationStatus.SessionWasExpired;
        const messageParams = basket ? basket.at(0).params : {};

        this.dialogService.openWithInput(userProfileValidationDialogRoute, {
          ...messageParams,
          paymentStatus: message,
        });

        // returns undefined to prevent default error handling
        return throwError$(void 0);
      } else {
        return throwError$(response);
      }
    }));
  }
}
